module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#health",
      toString: function () {
        return this.url;
      }
    }